// eslint-disable-next-line import/prefer-default-export
export const CHANGE_EMBEDDED_FIELD_DATA = 'actionId/CHANGE_EMBEDDED_FIELD_DATA'
export const CLEAR_EMBEDDED_DATA = 'CLEAR_EMBEDDED_DATA'
